module.exports = __webpack_public_path__ + "img/Ticto-5-pt.fc4a2ea4.png";